import type { VideoItem } from '@/mocks/videos';
import VideoCard from './VideoCard';

interface VideoGridProps {
  videos: VideoItem[];
  title?: string;
}

export default function VideoGrid({ videos, title }: VideoGridProps) {
  return (
    <section className="px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-7xl mx-auto">
        {title && (
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">{title}</h2>
          </div>
        )}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {videos.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}